import React from 'react';
import { Body, Box, Button, Icon, Link, Stack } from '@hover/blueprint';
import { iFacebook, iTwitter, iYoutube } from '@hover/icons';
import FooterNavbar from './navbar';
import HoverAppLogo from '../../../assets/images/hover-app-icon.svg';
import { PARTNER_BEACON_FOOTER_LINKS } from '../../../constants';

const Footer = () => (
  <Box d="block" maxWidth="8xl" w="100%">
    <FooterNavbar
      navbarItems={PARTNER_BEACON_FOOTER_LINKS}
      appURLs={{
        googlePlay:
          'https://play.google.com/store/apps/details?id=to.hover.android.beacon',
        appstore: 'https://itunes.apple.com/us/app/id1271854359?mt=8',
      }}
      mb={{ base: 8, tablet: 16 }}
    />

    <Stack
      color="neutral.400"
      direction={{ base: 'column', tablet: 'row' }}
      maxWidth="6xl"
      w="100%"
      m="auto"
      py={8}
      borderTop="1px solid"
      borderColor="neutral.500"
    >
      <Stack
        direction="row"
        gap={4}
        mr="auto"
        ml={{ base: 'auto', tablet: 'initial' }}
        alignItems="center"
      >
        <HoverAppLogo alt="HOVER logo" />
        <Body size={400} color="inherit">
          © 2022 HOVER Inc.
        </Body>
      </Stack>

      <Stack
        direction={{ base: 'column-reverse', tablet: 'row' }}
        gap={3}
        alignItems="center"
      >
        <Stack direction="row" gap="inherit">
          <Link
            href="https://beacon.hover.to/terms-of-use/"
            size={400}
            color="inherit"
          >
            Terms
          </Link>
          <Link
            href="https://beacon.hover.to/privacy/"
            size={400}
            color="inherit"
          >
            Privacy
          </Link>
        </Stack>
        <Stack direction="row" gap="inherit">
          <Button
            as="a"
            aria-label="Facebook"
            href="https://www.facebook.com/hover3d/"
            shape="circle"
            fill="minimal"
          >
            <Icon size="default" icon={iFacebook} />
          </Button>
          <Button
            as="a"
            aria-label="Twitter"
            href="https://twitter.com/hover3d"
            shape="circle"
            fill="minimal"
          >
            <Icon size="default" icon={iTwitter} />
          </Button>
          <Button
            as="a"
            aria-label="Youtube"
            href="https://www.youtube.com/user/Hover3D"
            shape="circle"
            fill="minimal"
          >
            <Icon size="default" icon={iYoutube} />
          </Button>
        </Stack>
      </Stack>
    </Stack>
  </Box>
);

export default Footer;
